import {
  Defect,
  DefectPrimaryKeyId,
  DefectReviewStatus,
  IProjectType,
  List,
  ListPrimaryKeyId,
  PrimaryKeyId,
  Project,
  ProjectPrimaryKeyId,
  TenantRole,
} from "src/app/models";

export namespace CreateBlank {
  export const defect = (): Defect.Defect => {
    return {
      cloudId: -1 as DefectPrimaryKeyId,
      defectNumberString: "NEW",
      defectNumber: 0,
      area: "",
      element: "",
      issue: "",
      comments: "",
      created: new Date(),
      completed: undefined,
      dueDate: undefined,
      status: 0,
      priority: 1,
      lastModified: 0,
      reviewStatusId: DefectReviewStatus.NOT_REVIEWED,
      reviewStatus: "NOT REVIEWED",
    };
  };

  export const defectPhoto = ({
    path,
    cloudId = -1,
    defectId = -1,
    fullPath = "",
    thumbnail = "",
    filename = "",
    createdBy = "",
    created = new Date(),
  }: _CreateBlankDefectPhoto): Defect.Photo => {
    filename = filename || new Date().getTime().toString();
    return {
      cloudId,
      defectId,
      fullPath: fullPath || path || "",
      thumbnail: thumbnail || fullPath || path || "",
      filename: `${filename}.jpeg`,
      createdBy,
      created,
    };
  };

  export const list = ({
    cloudId = -1 as ListPrimaryKeyId,
    projectCloudId = -1 as ProjectPrimaryKeyId,
    unit = "",
    address = "",
    floor = "",
    notes = "",
    type = IProjectType.HOUSE,
    projectAddress = "",
  }: _CreateBlankList): List.List => {
    return {
      cloudId,
      projectCloudId,
      unit: unit.trim(),
      address: address.trim(),
      floor: floor.trim(),
      notes,
      projectAddress,
      type,
      lastModified: 0,
    };
  };

  export const project = ({
    id = -1 as ProjectPrimaryKeyId,
    name = "",
    reference = "",
    client = "",
    address = "",
    city = "",
    postcode = "",
    state = "",
    country = "",
    type = IProjectType.HOUSE,
    created = new Date().toISOString(),
    role = TenantRole.owner,
    lastModified = 0,
    clientEnabled = false,
    photo = { url: "", photoId: -1 as PrimaryKeyId },
  }: _CreateBlankProject): Project.Project => {
    return {
      id,
      type,
      created,
      // Form fields
      name: `${name}`.trim(),
      reference: `${reference}`.trim(),
      client: `${client}`.trim(),
      address: `${address}`.trim(),
      city: `${city}`.trim(),
      postcode: `${postcode}`.trim(),
      state: `${state}`.trim(),
      country: `${country}`.trim(),
      // Not req'd for saving to device
      // contractors: this.project?.contractors || [],
      lastModified,
      role,
      photo,
      clientEnabled,
    };
  };
}

interface _CreateBlankDefectPhoto extends Partial<Defect.Photo> {
  path: string;
}

interface _CreateBlankList extends Partial<List.List> {}

interface _CreateBlankProject extends Partial<Project.Project> {}
